import {FaxQuery} from "@/components/fax/queries.generated";
import {UpdateFaxMutationVariables} from "@/components/fax/mutations.generated";
import {NonPaymentBlockingType} from "@/api";

export function createInitialData(fax?: FaxQuery): UpdateFaxMutationVariables {
    if (!fax)
        return {
            id: 0,
            outgoingCallBarringAdmin: [],
            outgoingCallBarringOperator: [],
            nonPaymentBlockingType: NonPaymentBlockingType.NotBlocked,
            headerInfo: "",
            headerNumber: "",
            incomingEmailAddress: "",
            senderEmailAddress: "",
            password: "",
            notifyUnsuccessfulReceiving: true,
            additionalFaxSendingEmails: {emails: []},
        };

    return {
        id: fax.faxes.items[0].id,
        outgoingCallBarringAdmin: fax.faxes.items[0].outgoingCallBarringAdmin,
        outgoingCallBarringOperator: fax.faxes.items[0].outgoingCallBarringOperator,
        nonPaymentBlockingType: fax.faxes.items[0].number.nonPaymentBlockingType,
        headerInfo: fax.faxes.items[0].headerInfo,
        headerNumber: fax.faxes.items[0].headerNumber,
        incomingEmailAddress: fax.faxes.items[0].incomingEmailAddress,
        senderEmailAddress: fax.faxes.items[0].senderEmailAddress,
        password: fax.faxes.items[0].password,
        notifyUnsuccessfulReceiving: fax.faxes.items[0].notifyUnsuccessfulReceiving,
        additionalFaxSendingEmails: {
            emails: fax.faxesEmails.items.map((email) => ({
                displayName: email.extension.displayName,
                enableBodyProcess: email.enableBodyProcess,
                enableProgressFeedback: email.enableProgressFeedback,
                userId: email.extensionId,
                id: email.id,
                notificationEmail: email.extension.notificationEmail,
                shortNumber: email.extension.number.shortNumber,
            })),
        },
    };
}
